import { Component, OnInit, AfterViewInit } from '@angular/core';
import { SubscriptionService } from '../../../services/subscription.service';
import { VacationService } from '../../../services/vacation.service';
import { ModalService } from '../../../services/modals.service';
import { GoogleAnalyticsService } from '../../../services/google-analytics.service';
import { openModal, closeModal, closeModalWithoutRemovingBackdrop } from '../../../shared/modal-functions';
import { responseIsSuccess } from '../../../shared/helper-functions';
import { arrayContainsValue, arrayIsDefinedAndContainsKey } from '../../../shared/array-functions';
import { subscriptionViewSpanish, vacationView } from '../subscription.static.data';
import * as moment from 'moment';
declare var jQuery: any;

@Component({
  selector: 'app-schedule-vacation',
  templateUrl: './schedule-vacation.component.html',
  styleUrls: ['../../../app.component.css']
})
export class ScheduleVacationComponent implements OnInit, AfterViewInit {
  // Static data
  subscriptionView: any;
  vacationView: any;
  // Control view
  openModal: any;
  closeModal: any;
  closeModalWithoutRemovingBackdrop: any;
  // Response data
  responseTitle: string;
  responseBody: string;
  responseAction: string;
  schedulingVacationInProgress: boolean;
  // User data
  invalidDate: boolean;
  vacation: any = {
    fromDate: undefined,
    toDate: undefined
  }

  constructor(private subscriptionService: SubscriptionService, private vacationService: VacationService, public modalService: ModalService, public googleAnalyticsService: GoogleAnalyticsService) { 
    this.subscriptionView = subscriptionViewSpanish;
    this.vacationView = vacationView;
    this.openModal = openModal;
    this.closeModal = closeModal;
    this.closeModalWithoutRemovingBackdrop = closeModalWithoutRemovingBackdrop;
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const minimumDate = moment(this.subscriptionService.cutOffDrawDate, 'YYYY-MM-DD').toDate();
    const maximumDate = moment(this.subscriptionService.cutOffDrawDate, 'YYYY-MM-DD').add(4, 'weeks').toDate();
    jQuery('#startDatepicker').datetimepicker({
      format: 'DD/MM/YYYY',
      ignoreReadonly: true,
      allowInputToggle: true,
      minDate: minimumDate,
      maxDate: maximumDate
    });
    jQuery('#endDatepicker').datetimepicker({
      format: 'DD/MM/YYYY',
      ignoreReadonly: true,
      allowInputToggle: true,
      minDate: minimumDate,
      maxDate: maximumDate
    });
  }

  continue() {
    this.invalidDate = false;
    this.vacation.fromDate = jQuery('#startDatepicker').find('input').val();
    this.vacation.toDate = jQuery('#endDatepicker').find('input').val();
    moment(this.vacation.fromDate, 'DD/MM/YYYY').isSameOrBefore(moment(this.vacation.toDate, 'DD/MM/YYYY')) ? this.openModal('#confirmVacationModal') : this.invalidDate = true;
  }

  submitVacation() {
    this.schedulingVacationInProgress = true;
    const fromDate = moment(this.vacation.fromDate, 'DD/MM/YYYY').format('MM/DD/YYYY');
    const toDate = moment(this.vacation.toDate, 'DD/MM/YYYY').format('MM/DD/YYYY');
    this.vacationService.scheduleVacation(this.subscriptionService.selectedSubscriptionId, fromDate, toDate).subscribe((response) => {
      this.schedulingVacationInProgress = false;
      this.closeModalWithoutRemovingBackdrop('#scheduleVacationModal');
      this.closeModalWithoutRemovingBackdrop('#confirmVacationModal');
      if(responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_InsertVacation') && response['CMS_InsertVacation'][0]['InsertVacation'] === 'True') {
        this.vacationService.getVacationList(this.subscriptionService.selectedSubscriptionId);
        this.openModal('#responseSubscriptionModal');
        this.responseTitle = vacationView.successSchedulingVacation.title;
        this.responseBody = vacationView.successSchedulingVacation.body;
        this.responseAction = vacationView.successSchedulingVacation.action;
        this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Confirmando_Vacaciones_Programadas');
      } else if(responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_InsertVacation') && response['CMS_InsertVacation'][0]['InsertVacation'] === 'False') {
        this.openModal('#responseSubscriptionModal');
        this.responseTitle = vacationView.errorSchedulingVacation.title;
        this.responseBody = vacationView.errorSchedulingVacation.body;
        this.responseAction = vacationView.errorSchedulingVacation.action;
        this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Error_Vacaciones_Fuera_de_Fecha');
      } else if(responseIsSuccess(response) && arrayIsDefinedAndContainsKey(response, 'CMS_InsertVacation') && response['CMS_InsertVacation'][0]['InsertVacation'] === 'Existing') {
        this.openModal('#responseSubscriptionModal');
        this.responseTitle = vacationView.schedulingExistingVacation.title;
        this.responseBody = vacationView.schedulingExistingVacation.body;
        this.responseAction = vacationView.schedulingExistingVacation.action;
        this.submitGAEvent('Mi_Suscripcion_SAM', 'Click', 'Pantalla_Confirmando_Error_Vacaciones_Existentes');
      }
    });
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/components/subscription/schedule-vacation/schedule-vacation.component.ts